import types from './types';

export const setStep = step => ({
	type: types.SET_ACTIVE_STEP,
	payload: step
});

export const resetStore = () => ({
	type: types.RESET_STORE
});

export const setFieldInfo = object => ({
	type: types.SET_FIELD_INFO,
	payload: object
});

export const setDataToSubmit = object => ({
	type: types.SET_DATA_TO_SUBMIT,
	payload: object
});

export const setDiscountFieldInfo = object => ({
	type: types.SET_DISCOUNT_FIELD_INFO,
	payload: object
});

export const setDiscountDataToSubmit = object => ({
	type: types.SET_DISCOUNT_DATA_TO_SUBMIT,
	payload: object
});

export const setWindowSize = object => ({
	type: types.SET_WINDOW_SIZE,
	payload: object
});

export const setErrorMessagesVisible = status => ({
	type: types.SET_ERROR_MESSAGES_VISIBLE,
	payload: status
});

export const deleteKey = key => ({
	type: types.DELETE_KEY,
	payload: key
});
